// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PedidosProvider } from './context/PedidosContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PedidosProvider>
      <App />
    </PedidosProvider>
  </React.StrictMode>
);
